"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectField = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const register_1 = require("../../register");
const ObjectField = (objClass) => {
    const serializer = {
        serialize: (value, buf) => {
            const props = Object.getPrototypeOf(value)[register_1.propertySerializerName];
            for (const propName of Object.keys(props)) {
                buf = props[propName].serialize(value[propName], buf);
            }
            return buf;
        },
        deserialize: (buf) => {
            const props = objClass.prototype[register_1.propertySerializerName];
            const obj = new objClass();
            for (const prop of Object.keys(props)) {
                const deserializationResult = props[prop].deserialize(buf);
                obj[prop] = deserializationResult[0];
                buf = deserializationResult[1];
            }
            return [obj, buf];
        },
    };
    return (0, register_1.buildField)(serializer)();
};
exports.ObjectField = ObjectField;
//# sourceMappingURL=object.js.map